import * as Constant from '.././Constant/Constant';
export function AuthHeader() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem(Constant.LOCAL_STORAGE_USER_KEY));
    if (user && user.data) {
        return { 'Content-Type': 'application/json','x-auth-id':user.data.user_id,'x-auth-token':user.data.token};
    } else {
        return {};
    }
}